<template>
    <div class="header-bar">
        <!--左边内容-->
        <div class="inner-wrapper">
            <div class="left-area">

                <!--网站地址-->
                <!-- <div>
                    <label class="refresh" @click="refreshPage">
                        <i class="el-icon-refresh"></i>
                    </label>
                    <span>首页</span>
                    <span>{{mapStr}}</span>
                </div> -->
            </div>

            <!--右边内容-->
            <div class="right-area">
                <!-- 未登录状态 -->
                <div class="noLogin" v-if="!hasLogin">
                    <span class="login-btn" @click="goLogin">登录</span>                    
                    <span class="login-btn" @click="goRegister">注册</span>
                </div>      
                
                <!-- 登录状态-->
                <!--工具清单-->
                <ul v-if="hasLogin">
                    <!--全屏-->
                    <li @click="change_full_screen">
                        <i :title="fullscreen ? '取消全屏' : '全屏'" :class="{'el-icon-full-screen' : !fullscreen, 'el-icon-menu' : fullscreen}"></i>
                    </li>
                    <!--消息-->
                    <li>
                        <i class="el-icon-bell"></i>
                    </li>
                </ul>

                <!--用户信息-->
                <div class="user-info" v-if="hasLogin">
                    <div class="face">
                        <img :src="face" />
                    </div>
                    <div class="drop-down">
                        <el-dropdown trigger="click" @command="handleCommand">
                            <span class="el-dropdown-link">
                                {{userInfo.username}}
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <!-- <el-dropdown-item command="2">
                                    <i class="el-icon-lock"></i>
                                    修改密码
                                </el-dropdown-item> -->
                                <el-dropdown-item command="3">
                                    <i class="el-icon-lock"></i>
                                    修改个人信息
                                </el-dropdown-item>
                                <el-dropdown-item command="1">
                                    <i class="el-icon-switch-button"></i>
                                    退出登录
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
        

        <!--修改密码-->
        <!-- <alert-box
            title="修改密码"
            width="45%"
            @close="closeDialog"
            :show.async="showDialog">
        </alert-box> -->

        <!--loading-box-->
        <RequestLoading :show="show"></RequestLoading>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import AlertBox from '../tool/AlertBox';
    import RequestLoading from '@/components/tool/RequestLoading';

    export default {
        name: "HeaderBar",
        components: {
            AlertBox,
            RequestLoading
        },
        props: {
            collapse: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            face() {
                return this.userInfo.face || 'https://www.ctdsb.net/images/logo-app.png';
            },
            ...mapGetters(['userInfo'])
        },
        data() {
            return {
                // showDialog: false,
                fullscreen: false,
                show: false,
                hasLogin: false,
                userid: '',
                token: '',
            };
        },
        created() {
            this.checklogin();
        },
        methods: {
            //展开收起
            toggle() {
                this.$emit('collapse');
            },
            goRegister() {
                this.$router.push('/login');
            },            
            goLogin() {
                this.$router.push('/login');
            },
            checklogin() {
                console.log(this.userInfo);
            //从local storage读取userid和token
                this.userid = this.userInfo.userid;
                this.token = this.userInfo.token;

                if(this.userid != '' && this.token != '') {
                    this.hasLogin = true;
                }
                else {
                    this.hasLogin = false;
                }
            },
            //退出登录
            exitLogin() {
                this.LOGOUT();

                //跳转到首页
                this.$router.push('/login');
            },
            handleCommand(command) {
                switch(parseInt(command)) {
                    case 1:
                        //退出登录
                        this.exitLogin();
                        break;
                    // case 2:
                    //     this.showDialog = true;
                    //     break;
                    case 3:
                        this.$router.push('/userInfo');
                        break;                   
                };
            },
            //关闭弹窗
            // closeDialog() {
            //     this.showDialog = false;
            // },

            //刷新页面
            refreshPage() {
                location.reload();
            },

            //页面全屏
            change_full_screen() {
                //全屏切换函数
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen; //判断全屏状态
            },

            //修改密码成功
            success() {
                this.closeDialog();
                setTimeout(() => {
                    this.exitLogin();
                }, 500);
            },

            ...mapMutations('admin', ['LOGOUT']),
        }
    }
</script>

<style scoped>
.header-bar .inner-wrapper {
    height: 50px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
}
.header-bar .inner-wrapper .left-area {
    display: flex;
    align-items: center;
    padding-left: 1rem;
}
.left-area label {
    cursor: pointer;
    font-size: 1.1rem;
}
.left-area label:hover{
    opacity: .8;
}
.left-area span {
    color: #606266;
    font-weight: 400;
    font-size: 1rem;
    margin-top: -4px;
}
.left-area label {
    margin: 0 1rem;
    font-size: 1.2rem;
}
.left-area span:first-child {
    font-weight: bold;
    margin-left: 1.5rem;
}
.left-area span:last-child {
    margin-left: 1rem;
    color: #606266;
}
.header-bar .right-area {
    display: flex;
    align-items: center;
    padding-right: 1rem;
    height: 100%;
}
.right-area ul {
    display: flex;
    height: 100%;
}
.right-area ul li {
    padding: 0 16px;
    height: 100%;
    display: flex;
    cursor: pointer;
    align-items: center;
}
.right-area ul li:hover {
    background-color: #F2F6FC;
}
.right-area ul li i {
    font-size: 1.3rem;
    color: #5a5e66;
}

/*用户信息*/
.right-area .user-info {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 1rem;
}
.right-area .user-info .face {
    display: flex;
    align-items: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #eee;
}
.right-area .user-info .face img {
    width: 100%;
}
.right-area .drop-down {
    margin-left: 8px;
    cursor: pointer;
}
.login-btn {
    float: right;
    line-height: 32px;
    color: #888;
    font-size: 16px;
    cursor: pointer;
    margin-right: 10px;
}
</style>